import { WORLD_WIDTH } from './config'

export interface Paddle {
  x: number
  /** Скорость по x, ед./с — нужна для угла отбоя. */
  vx: number
}

export function createPaddle(): Paddle {
  return { x: WORLD_WIDTH / 2, vx: 0 }
}

/** Ракетка догоняет цель (палец/мышь) экспоненциально и не выходит за поле. */
export function stepPaddle(
  p: Paddle,
  targetX: number,
  dt: number,
  followRate: number,
  halfWidth: number,
): Paddle {
  const clamped = Math.min(Math.max(targetX, halfWidth), WORLD_WIDTH - halfWidth)
  const x = p.x + (clamped - p.x) * (1 - Math.exp(-followRate * dt))
  return { x, vx: (x - p.x) / dt }
}
